<template>
    <div>
        <a href="#" class="d-block" v-on:click.prevent="showImageModal = true">
            <img v-bind:src="imageUrl" v-bind:width="imageWidth" v-bind:height="imageHeight" v-bind:alt="imageAlt" v-bind:class="imageClass">
        </a>
        <div class="image-modal modal" v-bind:class="{ show: showImageModal }" tabindex="-1" role="dialog" aria-modal="true" v-if="showImageModal" v-on:click.self.prevent="showImageModal = false">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <button type="button" class="close" v-on:click.prevent="showImageModal = false" aria-label="Close">
                        <span aria-hidden="true">×</span>
                    </button>
                    <div class="modal-body p-0">
                        <img v-bind:src="imageUrl" v-bind:width="imageWidth" v-bind:height="imageHeight">
                    </div>
                </div>
            </div>
        </div><!-- .tutorial-modal -->
    </div>
</template>

<script>
    export default {
        props: {
            imageUrl: {
                type: String,
                default: null,
            },
            imageWidth: {
                type: Number,
                default: null,
            },
            imageHeight: {
                type: Number,
                default: null,
            },
            imageAlt: {
                type: String,
                default: null,
            },
            imageClass: {
                type: String,
                default: null,
            },
        },
        data: function () {
            return {
                showImageModal: false,
            }
        }
    }
</script>
